interface TickWithGreenOutlineProps {
  width?: string;
  height?: string;
}

/** Brighter teal-green stroke for the outlined Case Appeal check icon. */
const CASE_APPEAL_GREEN = "#00B386";

/**
 * Hollow green circle with a checkmark for positive Case Appeal status.
 *
 * @param width - Optional SVG width
 * @param height - Optional SVG height
 * @returns SVG markup for an outlined green check icon
 */
const TickWithGreenOutline = ({
  width = "24",
  height = "24",
}: TickWithGreenOutlineProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle cx="12" cy="12" r="10" stroke={CASE_APPEAL_GREEN} strokeWidth="1.5" />
      <path
        d="M8 12L10.5 14.5L16 9"
        stroke={CASE_APPEAL_GREEN}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TickWithGreenOutline;
